/**
 * Created by tom on 3/03/17.
 */
import { IUsageLoggingService } from "src/services/IUsageLoggingService";
import {Panes} from "./panes";
import {optimizedResize} from "../utility/optimised_resize";

export interface INavScope extends ng.IScope {
	showPane: (string) => void;
	showPaneMobile: (string) => void;
	showModal(view: string, mobile?: boolean, fullUrl?: boolean);
	togglePane: (string, boolean) => void;
	isNavCollapsed : boolean;
	hamburgerContainerClass() : any;
	navbarClass(): any;
	xsNavUlClass() : any;
	loggedIn() : boolean;
	killSession(event: string | ng.IAngularEvent | any);
	expanded: {[key: string]: boolean};
	toggleMenuItem(event: ng.IAngularEvent, id: number): boolean;
	expandAllParents(id: number);
}

export class NavCtrl {
	public static $inject = ['$scope', 'usageLoggingService'];

	isLoggedIn() {
		return window['LTConfiguration']
			&& window['LTConfiguration']['userId'];
	}

	constructor(
		$scope: INavScope,
		usageLoggingService: IUsageLoggingService
	) {
		let lastLoginState = this.isLoggedIn();
		$scope.loggedIn = () => {
			let currentlyLoggedIn = this.isLoggedIn();
			if (currentlyLoggedIn !== lastLoginState && !currentlyLoggedIn) {
				usageLoggingService.resetSession();
			}
			lastLoginState = currentlyLoggedIn;
			return currentlyLoggedIn;
		};
		$scope.killSession = evt => {
			let triggered = false;
			if (evt === 'click') {
				triggered = true;
			} else if ('key' in evt) {
				if (evt.key === 'Enter') {
					triggered = true;
				}
			} else {
				triggered = true;
			}
			if (triggered) {
				console.log('killSession', evt);
				usageLoggingService.resetSession();
			}
		};

		$scope.isNavCollapsed = true;
		$scope.showPane = (view : string) => {
			// $location.search('b', view);
			$scope.$root.$broadcast('showPane', view);
		};


		let turnOffNav = () => {
			if (!$scope.isNavCollapsed && screen.width > 767) {
				$scope.isNavCollapsed = true;
			}
		};

		let turnOffNavInPhase = () => {
			if ($scope.$$phase) {
				turnOffNav();
			} else {
				$scope.$apply(turnOffNav);
			}
		};

		// window.addEventListener('orientationchange', turnOffNavInPhase);


		optimizedResize.add(turnOffNavInPhase);

		$scope.showPaneMobile = (view : string) => {
			$scope.$root.$broadcast('showPaneMobile', view);
		};

		$scope.togglePane = (view : string, isMobile : boolean = false) => {
			$scope.$root.$broadcast(Panes.Events.TOGGLE_PANE, view, isMobile);
		};

		$scope.showModal = (view: string, mobile: boolean = true, fullUrl: boolean = false) => {
			$scope.$root.$broadcast('showModal', view, mobile, fullUrl);
		};

		$scope.xsNavUlClass = () => {
			if (!$scope.isNavCollapsed) {
				return 'xs-nav-active';
			}
			return "";
		};

		$scope.hamburgerContainerClass = () => {
			return {
				"hamburger-container": true,
				"navbar-header": true,
				"is-active": !$scope.isNavCollapsed
			}
		};

		$scope.navbarClass = () => {
			return {
				"cs-cod-gray" : true,
				"visible-xs" : !$scope.isNavCollapsed
			}
		};

		$scope.toggleMenuItem = (event: ng.IAngularEvent, id: number) => {
			event.preventDefault();
			event.stopPropagation();
			$scope.expanded[id] = !$scope.expanded[id];

			let toHide = [document.querySelectorAll(`li[data-page-parent-id="${id}"]`)];
			while (toHide.length) {
				for (const node of toHide.pop()) {
					const nodeId = parseInt(node.getAttribute('data-page-id'));
					toHide.push(
						document.querySelectorAll(`li[data-page-parent-id="${nodeId}"]`)
					);
					$scope.expanded[nodeId] = false;
				}
			}

			return false;
		}

		$scope.expanded = {};

		$scope.expandAllParents = (parentId: number) => {
			let toExpand = [parentId];
			while (toExpand.length) {
				const id = toExpand.pop();
				$scope.expanded[id] = true;
				const node = document.querySelector(`li[data-page-id="${id}"]`);
				if (node) {
					const parentIdString = node.getAttribute('data-page-parent-id');
					if (parentIdString) {
						toExpand.push(parseInt(parentIdString));
					}
				}
			}
		}
	}
}
